import { Navigate, Outlet } from 'react-router'

import { useAuth } from '@/stores/auth'

/** Wraps authenticated routes — redirects to /signin when there's no user. */
export function ProtectedRoute() {
  const { user, status } = useAuth()
  if (status === 'loading') {
    return null
  }
  if (!user) {
    return <Navigate to="/signin" replace />
  }
  return <Outlet />
}

/** Wraps the signin page — redirects already-authenticated users to /. */
export function UnauthRoute({ children }: { children: React.ReactNode }) {
  const { user, status } = useAuth()
  if (status === 'loading') {
    return null
  }
  if (user) {
    return <Navigate to="/" replace />
  }
  return <>{children}</>
}
